import { CALENDAR_INDEX_TO_DOT } from './constants'

const calendarIDs = (process.env.GATSBY_GOOGLE_CALENDAR_ID || '').split(',')
export const getDotColorFromCalendarID = (calendarID: string) =>
  CALENDAR_INDEX_TO_DOT[calendarIDs.indexOf(calendarID)] || '#bbb'
